import React from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/Layout';
import Button from '../components/ui/Button';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiSmartphone, FiEdit3, FiArrowRight, FiShield } = FiIcons;

const Home = () => {
  return (
    <Layout>
      <div className="space-y-12 py-8">
        <div className="text-center space-y-4">
          <h1 className="text-4xl font-extrabold tracking-tight">
            One Card.<br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-red-500 to-white">Infinite Possibilities.</span>
          </h1>
          <p className="text-zinc-400 text-lg">
            Manage your smart business card links instantly. Scan to setup, login to edit.
          </p>
        </div>

        <div className="grid gap-4">
          <div className="p-6 rounded-2xl bg-zinc-900/50 border border-zinc-800 hover:border-red-500/50 transition-colors group">
            <div className="w-12 h-12 bg-zinc-800 rounded-full flex items-center justify-center mb-4 group-hover:bg-red-600 transition-colors">
              <SafeIcon icon={FiSmartphone} className="text-2xl text-white" />
            </div>
            <h3 className="text-xl font-bold mb-2">Scan & Go</h3>
            <p className="text-zinc-400">Scan your card's QR code or tap via NFC to instantly set up or visit your link.</p>
          </div>

          <div className="p-6 rounded-2xl bg-zinc-900/50 border border-zinc-800 hover:border-red-500/50 transition-colors group">
            <div className="w-12 h-12 bg-zinc-800 rounded-full flex items-center justify-center mb-4 group-hover:bg-red-600 transition-colors">
              <SafeIcon icon={FiEdit3} className="text-2xl text-white" />
            </div>
            <h3 className="text-xl font-bold mb-2">Easy Updates</h3>
            <p className="text-zinc-400">Changed your job? Update your destination link in seconds using your secret code.</p>
          </div>
        </div>

        <div className="space-y-4">
          <h3 className="text-center text-sm font-semibold text-zinc-500 uppercase tracking-wider">Quick Actions</h3>
          <div className="grid grid-cols-1 gap-3">
            <Link to="/editqr">
              <Button variant="outline" className="w-full">
                <span>I have an Edit Code</span>
                <SafeIcon icon={FiArrowRight} />
              </Button>
            </Link>
            <Link to="/admin/login">
              <Button variant="secondary" className="w-full text-zinc-400 hover:text-white border-zinc-800 hover:border-zinc-600">
                <SafeIcon icon={FiShield} />
                <span>Admin Dashboard</span>
              </Button>
            </Link>
          </div>
          <div className="text-center text-xs text-zinc-600">
            To set up a card, scan the QR code on the physical card.
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Home;